<div class="bg_message"></div>
<div class="bottom_message" id="message_form">
  <div class="wrap">
    <div class="ttl">{{ 'Sections.ModalError.Header' | translate }}</div>
    <div class="message">
      <div class="txt error-red" *ngIf="errors && errors.length > 0">
        <span *ngFor="let error of this.errors">{{error}}<br /></span>
      </div>
    </div>
    <a class="close close_modal_ref" (click)="activeModal.close()"></a>
  </div>
</div>
